import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/core/services/api.service';
import { Observable } from 'rxjs';
import { SocketService } from 'src/app/core/services/socket.service';

@Injectable({
  providedIn: 'root',
})
export class ContactsService {
  public contacts: any = [];
  constructor(private _apis: ApiService) {}

  public loadContacts() {
    this._apis.contactsGet().subscribe(
      (res) => {
        if (res && res.data && res.data.length > 0) {
          // Map backend fields to frontend expectations
          this.contacts = res.data.map((c: any) => ({
            ...c,
            photo: c.profileImage || 'assets/images/avatar-placeholder.png',
            contactId: c._id, // Map backend user _id to contactId for actions
            phone: c.phone || c.address?.phone || 'N/A',
          }));
        } else {
          this.contacts = [];
        }
      },
      (err) => {
        console.log('Failed to load contacts, using fallback data');
        this.contacts = [];
      },
    );
  }

  private getFakeContacts() {
    return [
      {
        contactId: '1',
        userId: 'u1',
        name: 'Soffie Rivera',
        phone: '+1 555 010 1234',
        email: 'soffie.rivera@example.com',
        country: 'USA',
        photo: 'assets/images/avatar-eleanor.jpg',
        is_online: true,
      },
      {
        contactId: '2',
        userId: 'u2',
        name: 'Lee Chen',
        phone: '+86 10 5550 5678',
        email: 'lee.chen@global.me',
        country: 'China',
        photo: 'assets/images/avatar-floyd.jpg',
        is_online: false,
      },
      {
        contactId: '3',
        userId: 'u3',
        name: 'Maria Thorne',
        phone: '+44 20 7946 0123',
        email: 'm.thorne@cyber.net',
        country: 'UK',
        photo: 'assets/images/avatar-isabella.jpg',
        is_online: true,
      },
      {
        contactId: '4',
        userId: 'u4',
        name: 'Elena Rodriguez',
        phone: '+34 91 123 4567',
        email: 'elena.rod@tech.es',
        country: 'Spain',
        photo: 'assets/images/avatar-jane.jpg',
        is_online: true,
      },
      {
        contactId: '5',
        userId: 'u5',
        name: 'Hiroshi Tanaka',
        phone: '+81 3 1234 5678',
        email: 'h.tanaka@neo.jp',
        country: 'Japan',
        photo: 'assets/images/avatar-jenny.jpg',
        is_online: false,
      },
      {
        contactId: '6',
        userId: 'u6',
        name: 'Chris Rock',
        phone: '+1 39 0931 1234',
        email: 'chris.rock@neo.jp',
        country: 'Japan',
        photo: 'assets/images/avatar-robert.jpg',
        is_online: false,
      },
    ];
  }

  public reloadContacts() {
    this.contacts = [];
    this.loadContacts();
  }

  public updateActiveStatus(data: any) {
    console.log('Updating user online status...');
    this.contacts.forEach((ele: any) => {
      let found = data.find(function (val: any) {
        if (val == ele.userId) return true;
        return false;
      });
      if (found) {
        ele.is_online = true;
      } else {
        ele.is_online = false;
      }
    });
  }

  public syncContacts(contacts: any[]): Observable<any> {
    return this._apis.contactsSync({ contacts });
  }

  public inviteContact(contact: any): Observable<any> {
    return this._apis.contactsInvite(contact);
  }
}
